import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ESGSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  const slides = [
    {
      title:
        "Implementing AccelTRACK has been a game-changer for our organization. The platform’s comprehensive ESG data management capabilities have streamlined our reporting processes, making it easier for us to track and report on our sustainability initiatives. One of the standout features is the deep customization options available, allowing us to tailor the platform to meet our specific needs. The seamless integration with our existing systems and the user-friendly interface has significantly reduced the learning curve for our team.",
      subtitle:
        "— S.M. Vermaak Company Secretary / Group Risk and Compliance Executive",
    },
    // Add more slides here if needed
    {
      title:
        "AccelTRACK has truly transformed the way we approach ESG reporting at Tongaat Hulett Limited. Prior to us adopting the platform, managing the complexities of environmental, social, and governance data across our operations was a significant challenge, with significant reliance on manual systems. AccelTRACK has changed that completely by serving as a comprehensive, one-stop solution that not only simplified the process but also provided us with the tools to go above and beyond our compliance obligations.",
      subtitle:
        "This distinction validates our platform’s powerful capabilities in ESG data management, regulatory alignment, and user-driven innovation.",
    },
  ];

  return (
    <div className="acceltrack-slide esg-slide">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="Industryslider">
            <h5>{slide.title}</h5>
            <p>{slide.subtitle}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ESGSlider;
